import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppUtils } from 'src/app/shared/app.utils';
import { AttachmentService } from '../../../services/attachment.service';
import { AuthService } from '../../../auth/auth.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'ness-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent {
  isSLUser: Boolean = true;

  constructor(
    private authService: AuthService,
    private attachmentService: AttachmentService) { }

  ngOnInit() {
    this.isSLUser = this.authService.hasUserType(['StateLocalLE']);
  }

  public OnDownloadClick(filetype: string): void {
    this.attachmentService.downloadHelpDocument(filetype).subscribe((response: HttpResponse<Blob>) => {
      let contentDisposition = response.headers.get('content-disposition');
      let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');
      AppUtils.embedDownloadLink(response.body, filename);
      },
      (err:any) => {
        console.log(err);
      });
  }

}
